import React, { createContext, useState, useContext } from 'react';
import { QuoteInfo } from '../api/types/search-quote-response';

interface ConsolidatedSummaryContextProps {
    quoteInfos: QuoteInfo[];
    setQuoteInfos: React.Dispatch<React.SetStateAction<QuoteInfo[]>>;
}

const ConsolidatedSummaryContext = createContext<ConsolidatedSummaryContextProps | undefined>(undefined);

export const useConsolidatedSummary = () => {
    const context = useContext(ConsolidatedSummaryContext);
    if (!context) {
        throw new Error('useConsolidatedSummary must be used within a ConsolidatedSummaryProvider');
    }
    return context;
};

export const ConsolidatedSummaryProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [quoteInfos, setQuoteInfos] = useState<QuoteInfo[]>([]);

    return (
        <ConsolidatedSummaryContext.Provider value={{ quoteInfos, setQuoteInfos }}>
            {children}
        </ConsolidatedSummaryContext.Provider>
    );
};